<template>
    <div>
        <div class="civiichat-form-container">
            <div>
                <p class="civiichat-data-usage">{{dataUsageMessage}}</p>
            </div>
            <div class="civiichat-form-group">
                <label :disabled="blockInputs" class="civiichat-form-label">Nombre completo:</label>
                <input :disabled="blockInputs" class="civiichat-form-control" v-model="credentials.fullname">
            </div>
            <div class="civiichat-form-group">
                <label :disabled="blockInputs" class="civiichat-form-label">Nro Identificación:</label>
                <input :disabled="blockInputs" class="civiichat-form-control" v-model="credentials.id">
            </div>
            <div class="civiichat-form-group">
                <label :disabled="blockInputs" class="civiichat-form-label">Celular:</label>
                <input :disabled="blockInputs" class="civiichat-form-control" v-model="credentials.phone">
            </div>
            <div class="civiichat-form-group">
                <label :disabled="blockInputs" class="civiichat-form-label">Correo electrónico:</label>
                <input :disabled="blockInputs" class="civiichat-form-control" v-model="credentials.email">
            </div>
            <div v-if="showFormError">
                <p>{{formErrorMessage}}</p>
            </div>
            <div class="civiichat-form-group">
                <div class="civiichat-button-container">
                    <button :disabled="blockInputs" class="civiichat-form-button" @click="onAcceptHandler">Aceptar</button>
                </div>
                <div class="civiichat-button-container">
                    <button :disabled="blockInputs" class="civiichat-form-button" @click="onCancelHandler">Cancelar</button>
                </div>   
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { civiiChat } from '@/civii-chat/actions/civiiChatActions.js'
import { ENDPOINT_ACCEPT_TERMS_AND_CONDITIONS, ENDPOINT_REJECT_TERMS_AND_CONDITIONS } from '@/civii-chat/scripts/civiiChatUrls.js'
import { mapActions, mapMutations } from 'vuex';
export default {
    props: {
        userData: {
            type: [Object]
        },
        startTime: {
            type: [Number]
        }
    },
    data: function(){
        return {
            dataUsageMessage: '',
            showFormError: false,
            formErrorMessage: '',
            blockInputs: false,
            credentials: {
                fullname: null,
                id: null,
                email: null,
                phone: null 
            }
        }
    },
    methods: {
        ...mapMutations(['addMessage', 'setDisableInput']),
        ...mapMutations('civiiChat', ['setUserCredentials']),
        ...mapActions('civiiChat', ['closeConnection']),
        allCredentialsFilled(){
            return this.credentials.fullname && this.credentials.id && this.credentials.email && this.credentials.phone
        },
        resetFormErrorFields(){
            this.showFormError = false;
            this.formErrorMessage = '';
        },
        onAcceptHandler(){
            this.resetFormErrorFields();
            if(this.allCredentialsFilled()){
                this.setDisableInput(false);

                let fullname = this.credentials.fullname.trim();
                let id = this.credentials.id.trim();
                let email = this.credentials.email.trim();
                let phone = this.credentials.phone.trim();

                sessionStorage.setItem('civiichatFullname', fullname);
                sessionStorage.setItem('civiichatIdUser', id);
                sessionStorage.setItem('civiichatEmail', email);
                sessionStorage.setItem('civiichatPhone', phone);

               
                let userAgreementData = {
                    nombreCompleto: fullname,
                    numeroIdentificacion: id,
                    correoElectronico: email,
                    telefonoContacto: phone,
                    codigoOperacion: window.civiiConf.workspaceId,
                    codigoConversacion: this.credentials.conversationId
                }

                axios.post(ENDPOINT_ACCEPT_TERMS_AND_CONDITIONS, userAgreementData)
                .then( response => {
                    this.setUserCredentials(userAgreementData);
                    this.blockInputs = true;
                })
                .catch( error => {
                    console.log(error);
                    let errorMessage = {
                        type: 'Normal',
                        side: 'left',
                        messages: [
                            { text: 'lo lamento ha ocurrido un error tratando de conectarte con un agente. '+ window.civiiConf.civiiChat.keepTalkingWithCiviiMessage }
                        ]
                    }
                    this.addMessage(errorMessage);
                    this.closeConnection();
                })
            } else {
                this.showFormError = true;
                this.formErrorMessage = 'Porfavor llene todos los campos';
                setTimeout(this.resetFormErrorFields, 2500);
            }
        },
        onCancelHandler(){
            
            axios.post(ENDPOINT_REJECT_TERMS_AND_CONDITIONS, {
                codigoOperacion: window.civiiConf.workspaceId,
                codigoConversacion: this.credentials.conversationId
            }).then( () => {
                this.closeConnection();
                this.resetFormErrorFields();
                this.blockInputs = true;
                let keepTalkingMessage = {
                    type: 'Normal',
                    side: 'left',
                    messages: [
                        { text: window.civiiConf.civiiChat.keepTalkingWithCiviiMessage }
                    ]
                }
                this.addMessage(keepTalkingMessage);
            })
        }
    },
    created(){
        this.dataUsageMessage = window.civiiConf.civiiChat.dataUsageMessage;
        if(this.userData){
            console.log(this.userData);
            this.credentials.conversationId = this.userData.conversationId;
            this.credentials.fullname = this.userData.nombreUsuario;
            this.credentials.id = this.userData.idUsuario;
            this.credentials.email = this.userData.email;
            this.credentials.phone = this.userData.phone;
        }

        if( ((this.startTime || 0) + 5000) <  new Date().getTime()){
            this.blockInputs = true;
        }
    }
}
</script>

<style>
.civiichat-data-usage {
    text-align: justify;
    font-size: small;
}

.civiichat-form-container {
    border-radius: 3px;
    border: solid 1px #CCC;
    padding: 0.5em;
}

.civiichat-form-group {
    display: flex;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

.civiichat-form-label {
    width: 50%;
    font-size: .75em;
}

.civiichat-form-control {
    width: 50%;
    border-radius: 3px !important;
    border: solid 1px #CCC;
    padding: .25em !important;
}

.civiichat-button-container {
    width: 50%;
    padding-left: .25em;
    padding-right: .25em;
}

.civiichat-form-button {
    width: 100%;
    cursor: pointer;
    padding: .5em;
    font-family: inherit;
    border: 1px solid #CCC;
    border-radius: .5em;
    box-shadow: 0 .25em 0 0 #CCC, 0 .2em .4em rgba(0,0,0,.4);
}
</style>


// WEBPACK FOOTER //
// src/civii-chat/components/CiviiChatForm.vue